import { FC, lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { DashboardWrapper } from '../modules/apps/dashboard/DashboardWrapper'
import { DashboardForecastWrapper } from '../modules/dashboard-forecast/DashboardForecastWrapper'
import { DashboardHRManagementWrapper } from '../modules/dashboard-hr-management/DashboardHRManagementWrapper'
import { DashboardHRMitraWrapper } from '../modules/dashboard-hr-mitra/DashboardHRMitraWrapper'
import { DashboardHRWrapper } from '../modules/dashboard-hr/DashboardHRWrapper'
import PartnerOrganizationPage from '../modules/partner-organization/PartnerOrganizationPage'
import { ReportBookingTypeWrapper } from '../modules/report-booking-type/ReportBookingTypeWrapper'
import { RushHourWrapper } from '../modules/report-rush-hour/RushHourWrapper'
import { TrendAnalysisWrapper } from '../modules/report-trend-analysis/TrendAnalysisWrapper'
import { RevenuePerformanceWrapper } from '../modules/revenue-performance/RevenuePerformanceWrapper'
import { RevenueSharingWrapper } from '../modules/revenue-sharing/RevenueSharingWrapper'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
const PrivateRoutes = () => {
  const UserManagementPage = lazy(() => import('../modules/user-management/UserManagementPage'))
  const PosPage = lazy(() => import('../modules/pos/PosPage'))
  const OrderPage = lazy(() => import('../modules/order-list/OrderPage'))
  const TransactionHistoryPage = lazy(
    () => import('../modules/transaction-history/TransactionHistoryPage')
  )
  const TransactionHistoryAdjustmentPage = lazy(
    () => import('../modules/transaction-history-adjustment/TransactionHistoryAdjustmentPage')
  )
  const ClosingShiftHistoryPage = lazy(
    () => import('../modules/closing-shift-history/ClosingShiftHistoryPage')
  )
  const TransactionReportPage = lazy(
    () => import('../modules/report-transaction/TransactionReportPage')
  )
  const BookOrderPage = lazy(() => import('../modules/book-order/BookOrder'))
  const KpiDashboard = lazy(() => import('../modules/kpi-home/KpiDashboard'))
  const KpiEmployeePage = lazy(() => import('../modules/kpi-home/KpiHomePage'))
  const KpiDetailManager = lazy(() => import('../modules/kpi-home/KpiDetailManager'))
  const KpiEmployeeDetail = lazy(() => import('../modules/kpi-home/KpiEmployeeDetail'))
  const ProductPage = lazy(() => import('../modules/product/ProductPage'))
  const ProductCategoryPage = lazy(() => import('../modules/product-category/ProductCategoryPage'))
  const ContractEmployeePage = lazy(
    () => import('../modules/human-resources/contract-employee/ContractEmployeePage')
  )
  const OutletPage = lazy(() => import('../modules/outlet/OutletPage'))
  const OutletCategoryPage = lazy(() => import('../modules/outlet-category/OutletCategoryPage'))
  const PartnershipContractPage = lazy(
    () => import('../modules/partnership-contract/PartnershipContractPage')
  )
  const OutletProjectionPage = lazy(
    () => import('../modules/outlet-projection/OutletProjectionPage')
  )
  const ProductCollectionPage = lazy(
    () => import('../modules/product-collection/ProductCollectionPage')
  )
  const ProductPricePage = lazy(() => import('../modules/product-price/ProductPricePage'))
  const ProductStockPage = lazy(() => import('../modules/product-stock/ProductStockPage'))
  const ProductStockOpnamePage = lazy(
    () => import('../modules/product-stock-opname/ProductStockOpnamePage')
  )
  const ChartOfAccountPage = lazy(() => import('../modules/chart-of-account/ChartOfAccountPage'))
  const SalesInvoicePage = lazy(() => import('../modules/sales-invoice/SalesInvoicePage'))
  const SalesPaymentChannelPage = lazy(
    () => import('../modules/sales-payment-channel/SalesPaymentChannelPage')
  )
  const PurchaseOrderInvoicePage = lazy(
    () => import('../modules/purchase-order-invoice/PurchaseOrderInvoicePage')
  )
  const ApprovalConfigurationPage = lazy(
    () => import('../modules/approval-configuration/ApprovalConfigurationPage')
  )
  const AssistanceTherapistPage = lazy(
    () => import('../modules/assistance-therapist/AssistanceTherapistPage')
  )
  const AttendanceReportPage = lazy(
    () => import('../modules/human-resources/attendance/AttendanceReportPage')
  )

  const ForcaseTargetSalesPage = lazy(
    () => import('../modules/forecast-target-sales/ForecastTargetSalesPage')
  )

  const FinanceConfigurationPage = lazy(
    () => import('../modules/finance-configuration/FinanceConfigurationPage')
  )

  const CustomerPage = lazy(() => import('../modules/sales-marketing/customer/CustomerPage'))

  const CmsPage = lazy(() => import('../modules/cms/CmsPage'))

  const MappingOutletPicPage = lazy(
    () => import('../modules/mapping-outlet-pic/MappingOutletPicPage')
  )

  const JournalEntryPage = lazy(() => import('../modules/journal-entry/JournalEntryPage'))

  const JournalHistoryPage = lazy(() => import('../modules/journal-history/JournalHistoryPage'))

  const GeneralLedgerPage = lazy(() => import('../modules/general-ledger/GeneralLedgerPage'))

  const ProfitLossPage = lazy(() => import('../modules/profit-loss/ProfitLossPage'))

  const BalanceSheetPage = lazy(() => import('../modules/balance-sheet/BalanceSheetPage'))

  const ClosingBookPeriodPage = lazy(
    () => import('../modules/closing-book-period/ClosingBookPeriodPage')
  )

  const CashFlowPage = lazy(() => import('../modules/cash-flow/CashFlowPage'))

  const CashFlowReportPage = lazy(() => import('../modules/cash-flow-report/CashFlowReportPage'))

  const PurchaseOrderRawMaterialPage = lazy(
    () => import('../modules/purchase-order-raw-material/PurchaseOrderRawMaterialPage')
  )

  const RawMaterialStockPage = lazy(
    () => import('../modules/raw-material-stock/RawMaterialStockPage')
  )

  const RawMaterialStockOpnamePage = lazy(
    () => import('../modules/raw-material-stock-opname/RawMaterialStockOpnamePage')
  )

  const RawMaterialPage = lazy(() => import('../modules/raw-material/RawMaterialPage'))

  const RawMaterialCategoryPage = lazy(
    () => import('../modules/raw-material-category/RawMaterialCategoryPage')
  )

  const SurveyPage = lazy(() => import('../modules/survey/SurveyPage'))

  const RawMaterialPricePage = lazy(
    () => import('../modules/raw-material-price/RawMaterialPricePage')
  )
  const InitialStockRawMaterialPage = lazy(
    () => import('../modules/initial-stock-raw-material/InitialStockRawMaterialPage')
  )
  const StockCardPage = lazy(() => import('../modules/stock-card/StockCardPage'))
  const PurchaseOrderPage = lazy(() => import('../modules/purchase-order/PurchaseOrderPage'))
  const PurchaseRequestPage = lazy(() => import('../modules/purchase-request/PurchaseRequestPage'))
  const PurchaseRequestApprovalPage = lazy(
    () => import('../modules/purchase-request-approval/PurchaseRequestApprovalPage')
  )
  const StoreRequestPage = lazy(() => import('../modules/store-request/StoreRequestPage'))
  const StoreRequestApprovalPage = lazy(
    () => import('../modules/store-request-approval/StoreRequestApprovalPage')
  )
  const StoreRequestTransferPage = lazy(
    () => import('../modules/store-request-transfer/StoreRequestTransferPage')
  )
  const StoreRequestReceivePage = lazy(
    () => import('../modules/store-request-receive/StoreRequestReceivePage')
  )
  const PurchaseOrderApprovalPage = lazy(
    () => import('../modules/purchase-order-approval/PurchaseOrderApprovalPage')
  )
  const PurchaseOrderReceivePage = lazy(
    () => import('../modules/purchase-order-receive/PurchaseOrderReceivePage')
  )
  const RawMaterialSupplierPage = lazy(
    () => import('../modules/raw-material-supplier/RawMaterialSupplierPage')
  )
  const RawMaterialSupplierCategoryPage = lazy(
    () => import('../modules/supplier-category/SupplierCategoryPage')
  )
  const SalesByProductPage = lazy(() => import('../modules/sales-by-product/SalesByProductPage'))
  const SalesByTreatmentage = lazy(
    () => import('../modules/sales-by-treatment/SalesByTreatmentPage')
  )
  const TransferPage = lazy(() => import('../modules/transfer/TransferPage'))
  const TransferRequestPage = lazy(() => import('../modules/transfer-request/TransferRequestPage'))
  const TransferReceivePage = lazy(() => import('../modules/transfer-receive/TransferReceivePage'))
  const RatingByOrderPage = lazy(() => import('../modules/rating-by-order/RatingByOrderPage'))
  const RatingByTherapistPage = lazy(
    () => import('../modules/rating-by-therapist/RatingByTherapistPage')
  )
  const EmployeePage = lazy(() => import('../modules/human-resources/employee/EmployeePage'))
  const LeaveRequestPage = lazy(
    () => import('../modules/human-resources/leave-request/LeaveRequestPage')
  )
  const LeaveAllowancePage = lazy(
    () => import('../modules/human-resources/leave-allowance/LeaveAllowancePage')
  )
  const SidebarPage = lazy(() => import('../modules/sidebar/SidebarPage'))

  const MembershipLevelPage = lazy(() => import('../modules/membership-level/MembershipLevelPage'))
  const RedeemPointPage = lazy(() => import('../modules/redeem-point/RedeemPointPage'))
  const VoucherPage = lazy(() => import('../modules/voucher/VoucherPage'))
  const RedeemPointHistoryPage = lazy(
    () => import('../modules/redeem-point-history/RedeemPointHistoryPage')
  )
  const VoucherCategoryPage = lazy(() => import('../modules/voucher-category/VoucherCategoryPage'))
  const ResetPointPage = lazy(() => import('../modules/reset-point/ResetPointPage'))
  const RewardPointPage = lazy(() => import('../modules/reward-point/RewardPointPage'))
  const MembershipTypePage = lazy(() => import('../modules/membership_type/MembershipTypePage'))
  const SalesByOutletPage = lazy(() => import('../modules/sales-by-outlet/SalesByOutletPage'))
  const SalesByGroupPage = lazy(() => import('../modules/sales-by-group/SalesByGroupPage'))
  const AccountReceivableAgingPage = lazy(
    () => import('../modules/account-receivable-aging/AccountReceivableAgingPage')
  )
  const AccountPayablePage = lazy(
    () => import('../modules/account-payable/AccountPayablePage')
  )
  const CommissionEmployeePage = lazy(
    () => import('../modules/commission-employee/CommissionEmployeePage')
  )
  const SalesVsClosingPage = lazy(() => import('../modules/sales-vs-closing/SalesVsClosingPage'))

  const DocumentPage = lazy(() => import('../modules/document/DocumentPage'))
  const PurchaseRequestConfigurationPage = lazy(
    () => import('../modules/purchase-request-configuration/PurchaseRequestConfigurationPage')
  )
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect root path to Dashboard */}
        <Route path='' element={<Navigate to='/dashboard' replace />} />
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='dashboard-hr' element={<DashboardHRWrapper />} />
        <Route path='dashboard-hr-management' element={<DashboardHRManagementWrapper />} />
        <Route path='dashboard-hr-mitra' element={<DashboardHRMitraWrapper />} />
        <Route path='book-order' element={<BookOrderPage />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='report/sales/revenue-sharing' element={<RevenueSharingWrapper />} />
        <Route path='report/sales/revenue-performance' element={<RevenuePerformanceWrapper />} />
        <Route path='report/sales/sales-forecast' element={<DashboardForecastWrapper />} />
        <Route path='report/sales/rush-hour' element={<RushHourWrapper />} />
        <Route path='report/sales/trend-analysis' element={<TrendAnalysisWrapper />} />
        <Route path='report/sales/report-booking-type' element={<ReportBookingTypeWrapper />} />
        <Route
          path='report/sales/*'
          element={
            <SuspensedView>
              <SalesPaymentChannelPage />
              <SalesByProductPage />
              <SalesByTreatmentage />
              <SalesByOutletPage />
              <SalesByGroupPage />
              <AccountReceivableAgingPage />
              <AccountPayablePage />
              <SalesVsClosingPage />
            </SuspensedView>
          }
        />
        <Route
          path='report/*'
          element={
            <SuspensedView>
              <RatingByOrderPage />
              <RatingByTherapistPage />
              <RedeemPointHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='master-data/*'
          element={
            <SuspensedView>
              <SidebarPage />
            </SuspensedView>
          }
        />
        <Route
          path='master-data/product/*'
          element={
            <SuspensedView>
              <ProductPage />
              <ProductCategoryPage />
              <ProductCollectionPage />
              <ProductPricePage />
              <ProductStockPage />
              <ProductStockOpnamePage />
            </SuspensedView>
          }
        />
        <Route
          path='human-resources/*'
          element={
            <SuspensedView>
              <EmployeePage />
              <ContractEmployeePage />
              <AttendanceReportPage />
              <LeaveRequestPage />
              <LeaveAllowancePage />
            </SuspensedView>
          }
        />
        <Route
          path='master-data/outlet/*'
          element={
            <SuspensedView>
              <OutletPage />
              <OutletCategoryPage />
              <PartnershipContractPage />
              <DocumentPage />
              <OutletProjectionPage />
            </SuspensedView>
          }
        />
        <Route
          path='master-data/raw-material/*'
          element={
            <SuspensedView>
              <RawMaterialPage />
              <RawMaterialCategoryPage />
              <RawMaterialPricePage />
              <InitialStockRawMaterialPage />
            </SuspensedView>
          }
        />
        <Route
          path='raw-material/*'
          element={
            <SuspensedView>
              <RawMaterialStockPage />
              <RawMaterialStockOpnamePage />
              <StoreRequestPage />
              <StoreRequestApprovalPage />
              <StoreRequestTransferPage />
              <StoreRequestReceivePage />
              <PurchaseOrderPage />
              <PurchaseRequestPage />
              <PurchaseRequestConfigurationPage />
              <PurchaseOrderApprovalPage />
              <PurchaseRequestApprovalPage />
              <PurchaseOrderReceivePage />
              <RawMaterialSupplierPage />
              <RawMaterialSupplierCategoryPage />
              <TransferPage />
              <TransferRequestPage />
              <TransferReceivePage />
              <StockCardPage />
            </SuspensedView>
          }
        />
        <Route
          path='survey/*'
          element={
            <SuspensedView>
              <SurveyPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='sales-marketing/cms/*'
          element={
            <SuspensedView>
              <CmsPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='finance-of-accounting/*'
          element={
            <SuspensedView>
              <ChartOfAccountPage />
              <JournalEntryPage />
              <JournalHistoryPage />
              <GeneralLedgerPage />
              <ProfitLossPage />
              <BalanceSheetPage />
              <CashFlowPage />
              <CashFlowReportPage />
              <ClosingBookPeriodPage />
            </SuspensedView>
          }
        />
        <Route
          path='invoice/*'
          element={
            <SuspensedView>
              <PurchaseOrderInvoicePage />
              <SalesInvoicePage />
            </SuspensedView>
          }
        />
        <Route
          path='down-payment/*'
          element={
            <SuspensedView>
              <PurchaseOrderRawMaterialPage />
            </SuspensedView>
          }
        />
        <Route
          path='sales-marketing/*'
          element={
            <SuspensedView>
              <CustomerPage />
              <ForcaseTargetSalesPage />
              <FinanceConfigurationPage />
              <CmsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/store/*'
          element={
            <SuspensedView>
              <PosPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/order/*'
          element={
            <SuspensedView>
              <OrderPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/*'
          element={
            <SuspensedView>
              <TransactionReportPage />
              <TransactionHistoryPage />
              <TransactionHistoryAdjustmentPage />
              <ClosingShiftHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/partner-organization/*'
          element={
            <SuspensedView>
              <PartnerOrganizationPage />
            </SuspensedView>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <ApprovalConfigurationPage />
            </SuspensedView>
          }
        />
        <Route
          path='user-management/*'
          element={
            <SuspensedView>
              <UserManagementPage />
            </SuspensedView>
          }
        />
        <Route
          path='user-management/mapping-outlet-pic/*'
          element={
            <SuspensedView>
              <MappingOutletPicPage />
            </SuspensedView>
          }
        />
        <Route
          path='user-management/assistance-therapist/*'
          element={
            <SuspensedView>
              <AssistanceTherapistPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/KPI/*'
          element={
            <SuspensedView>
              <KpiEmployeePage />
              <CommissionEmployeePage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='apps/KPI/commission-employee/list'
          element={
            <SuspensedView>
              <CommissionEmployeePage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='apps/KPI/therapist'
          element={
            <SuspensedView>
              <KpiEmployeePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/KPI/manager'
          element={
            <SuspensedView>
              <KpiDetailManager />
            </SuspensedView>
          }
        />
        <Route
          path='apps/KPI/manager/detail'
          element={
            <SuspensedView>
              <KpiEmployeeDetail />
            </SuspensedView>
          }
        />
        <Route
          path='crm/*'
          element={
            <SuspensedView>
              <MembershipLevelPage />
              <RedeemPointPage />
              <VoucherPage />
              <VoucherCategoryPage />
              <ResetPointPage />
              <RewardPointPage />
              <MembershipTypePage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
